(function ($) {
    var $timeout;

    $doc.on("click", ".part_ui_option [aria-expanded]", function (e) {
        var $el = $(this);
        e.preventDefault();
        e.stopPropagation();
        clearTimeout($timeout);

        $.fn.close = function () {
            $(this).removeClass("mod--toggled").next("[aria-hidden]").attr("aria-hidden", "true");
            $timeout = setTimeout(function () {
                $el.attr("aria-expanded", "false");
            }, 300);
        };
        $.fn.open = function () {
            $(this).addClass("mod--toggled").attr("aria-expanded", "true").next("[aria-hidden]").removeAttr("aria-hidden");
        };

        $("html").one("click", function (e) {
            if ($(e.target).closest('.part_ui_option').length === 0) {
                $el.close();
            }
        });
        if ($el.hasClass("mod--toggled")) {
            $el.close();
        } else {
            $el.open();
        }

        $el.next().find('label').one('click', function () {
            $el.find('i:not(.icon)').html($(this).find('i').html());
            $el.closest(".part_ui_option").removeClass("mod--placeholder");
            $el.close();
        });
    });

    $doc.find('.part_ui_option [aria-expanded]').each(function () {
        var $el = $(this);

        if ($el.next().find(':checked').length > 0) {
            $el.find('i:not(.icon)').html($el.next().find(':checked').parent().find('i').html());
            $el.closest(".part_ui_option").removeClass("mod--placeholder");
        }
    });

})(jQuery);